import grapesjs from 'grapesjs';
import loadBlocks from './blocks';
import loadComponents from './components';

export default grapesjs.plugins.add('gjs-standard-button', (editor, opts = {}) => {
  const config = {
    blocks: [
      'standardbutton',
    ],
    name: 'standardbutton',
    stylePrefix: 'gjs-',
    labelStandardButton: 'Botón Estándar',
    defText: 'Sample',
    category: 'Botones',
    ...opts,
  };
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    if (!(name in opts)) opts[name] = config[name];
  }
  loadBlocks(editor, config);
  loadComponents(editor, opts);
});
